// extracted by mini-css-extract-plugin
module.exports = {"container_field":"number_container_field__3adV8","label_field":"number_label_field__2wi-R"};